<template>
  <section>
    <div class="container">
      <div class="grid">
        <div 
          v-for="item, i in items" 
          :key="i"
          :class="['item', `item-${i + 1}`]"
          v-scrollanim
        >
          <div class="icon">
            <img :src="item.iconSrc" alt="">
          </div>
          <h2 class="title">{{item.title}}</h2>
          <p class="copy" v-html="item.copy"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          iconSrc: this.$getImgUrl('assets/icons/heart.webp'),
          title: "가장 친숙한",
          copy: `
            모두에게 친숙한 문자메시지 서비스에서<br>
            이제 이모티콘도 만나보세요.
          `
          // 문자 메시지의 진화, 이모티콘부터<br class="br-md">
          // 메시지 취소 등<br class="br-sm"> 가장 기본적인 기능을<br class="br-md">
          // 모두에게 친숙한 문자메시지 서비스에서 이제 이모티콘도 만나보세요.
        },
        {
          iconSrc: this.$getImgUrl('assets/icons/bubble.webp'),
          title: "다운로드 없이",
          copy: `
            별도의 앱을 설치해야 하는<br class="br-md">
            번거로운 단계는 필요 없어요,<br class="br-md">
            문자메시지에서 확인 해보세요
          `
        },
        {
          iconSrc: this.$getImgUrl('assets/icons/network.webp'),
          title: "데이터 없이",
          copy: `
            이모티콘부터 메시지 전송까지<br class="br-md">
            데이터 걱정없이<br>
            쿨하게 보낼 수 있어요.
          `
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
section {
  --section-gutter: 77px;
  --title-font-size: 26px;
  --copy-font-size: 14px; 
  --icon-size: 35px;
  padding: var(--section-gutter) 0;
  @media screen and (max-width: 768px) {
    --section-gutter: 50px;
  }
  @media screen and (max-width: 600px) {
    --title-font-size: 22px;
    --copy-font-size: 16px;
    --icon-size: 30px;
  }
  @media screen and (max-width: 480px) {
    --copy-font-size: 16px;
    &:deep br {
      display: none !important;
    }
  }
}
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 16px;
  margin: 0 auto;
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 40px;
  }
}

.icon {
  width: var(--icon-size);
  height: var(--icon-size);
  margin: 0 0 20px;
  img {
    width: 100%;
    height: auto;
  }
}

h2 {
  font-size: var(--title-font-size);
  font-weight: 700;
  color: #171717;
  margin: 0 0 12px;
}

p {
  font-size: var(--copy-font-size);
  color: #797B80;
  font-weight: 500;
}

// Scroll Anims
.item {
  position: relative;
}
.item.before-enter {
  transform: translate3d(0, 50%, 0);
  opacity: 0;
  .icon {
    transform: scale(0.0);
    opacity: 0;
  }
  .title {
    transform: translate3d(0, 50%, 0);
  }
}
.item.enter {
  transform: translate3d(0, 0%, 0);
  opacity: 1;
  transition: 450ms ease-in-out opacity, 500ms ease-in-out transform;
  .icon {
    transform: scale(1.0);
    transition: 150ms transform ease-in-out, 250ms ease-in-out opacity;
    opacity: 1;
    transition-delay: 300ms;
  }
   .title {
    transform: translate3d(0, 0%, 0);
    transition: 500ms transform ease-in-out;
    transition-delay: 100ms;
  }
}
.item-1.enter {
  transition-delay: 0;
}
.item-2.enter {
  transition-delay: 175ms;
}
.item-3.enter {
  transition-delay: 350ms;
}

</style>